import {Component, Inject, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';

@Component({
    selector: 'common-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss']
})
export class CommonAboutComponent implements OnInit {

    constructor(@Inject(DOCUMENT) public document: Document) {
    }

    ngOnInit(): void {
    }
}
